/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { ReducerKeys } from 'redux-stores/enums/reducerKey.enum';

import { SnackbarState, UtilityState } from '../interfaces';

const initialState: UtilityState = {
  snackbar: {
    color: '',
    message: '',
    autoHideDuration: 5000,
    open: false,
  },
  loading: {
    show: false,
  },
  header: {
    initialGetActiveTime: false,
    counterUpdateGetActiveTime: 0,
  },
};

const snackbarSlice = createSlice({
  name: ReducerKeys.Utility,
  initialState,
  reducers: {
    snackbarSetOpen(
      state: UtilityState,
      action: { type: string; payload: boolean },
    ) {
      state.snackbar.open = action.payload;
    },
    snackbarSetData(
      state: UtilityState,
      action: { type: string; payload: Partial<SnackbarState> },
    ) {
      state.snackbar.open =
        action.payload && action.payload.open !== undefined
          ? action.payload.open
          : state.snackbar.open;
      state.snackbar.message =
        action.payload?.message || state.snackbar.message;
      state.snackbar.color = action.payload?.color || state.snackbar.color;
    },
    setLoading(
      state: UtilityState,
      action: { type: string; payload: boolean },
    ) {
      state.loading.show = action.payload;
    },
    setHeaderInitialGetActiveTime(
      state: UtilityState,
      action: { type: string; payload: boolean },
    ) {
      state.header.initialGetActiveTime = action.payload;
    },
    setCounterUpdateGetActiveTime(
      state: UtilityState,
      action: { type: string; payload: number },
    ) {
      state.header.counterUpdateGetActiveTime = action.payload;
    },
  },
});

export const {
  snackbarSetData,
  snackbarSetOpen,
  setLoading,
  setHeaderInitialGetActiveTime,
  setCounterUpdateGetActiveTime,
} = snackbarSlice.actions;

export default snackbarSlice.reducer;
